import React, { useState } from 'react'
import { alpha, Box, SxProps, Typography } from '@mui/material'
import { ModeEdit } from '@mui/icons-material'

import { colors } from '@/theme/colors.theme'
import { IconButtonBg } from '@/theme/icon-button.theme'

type Props = {
  icon?: React.ReactNode
  title?: string
  data?: React.ReactNode
  sxProps?: SxProps
  click?: () => void
}

export function InfoPlayer({ icon, title, data, sxProps, click }: Props) {
  const [showClick, setShowClick] = useState(false)

  return (
    <Box
      sx={{
        marginBottom: '10px',
        border: `1px solid ${alpha(colors.white, 0.1)}`,
        borderRadius: '8px',
        padding: 1,
        display: 'flex',
        gap: 1,
        alignItems: 'center',
        position: 'relative',
        backgroundColor: alpha(colors.white, 0.05),
        width: '100%',
        ...sxProps,
      }}
      onMouseOver={() => setShowClick(true)}
      onMouseLeave={() => setShowClick(false)}
    >
      <Box>{icon}</Box>
      <Box overflow="hidden">
        {typeof title === 'string' || typeof title === 'number' ? (
          <Typography variant="caption" component="p" lineHeight="1rem">
            {title}
          </Typography>
        ) : (
          title
        )}
        {typeof data === 'string' || typeof data === 'number' ? (
          <Typography
            variant="caption"
            component="p"
            fontSize="12px"
            lineHeight="1rem"
            sx={{ opacity: 1, textTransform: 'capitalize' }}
          >
            {data || '-'}
          </Typography>
        ) : (
          <Box>{data}</Box>
        )}
      </Box>
      {click && showClick && (
        <IconButtonBg
          aria-label="edit profile"
          onClick={() => click()}
          size="small"
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            borderRadius: '50%',
          }}
        >
          <ModeEdit fontSize="inherit" />
        </IconButtonBg>
      )}
    </Box>
  )
}
